<template>
  <CreateEditCourseModal
    v-if="showCreateEditCourseModal"
    @closeModal="closeCreateEditCourseModal"
  />
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">Cursos</h6>
      <div class="ms-auto">
        <button
          type="button"
          class="btn btn-primary"
          title="Novo Curso"
          @click="showCreateEditCourseModal = true"
        >
          Novo Curso
        </button>
      </div>
    </div>
    <ListCourses :courses="courses" />
  </div>
</template>

<script>
import CreateEditCourseModal from '@/components/courses/courses/CreateEditCourseModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListCourses from '@/components/courses/courses/ListCourses.vue'

export default {
  name: 'Courses',

  components: {
    CreateEditCourseModal,
    LoadingData,
    ListCourses,
  },

  data() {
    return {
      loadData: true,
      showCreateEditCourseModal: false,
      courses: [],
    }
  },

  methods: {
    async getCourses() {
      try {
        this.courses = await this.$store.dispatch('getCourses')
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    closeCreateEditCourseModal(loadListCourses) {
      if (loadListCourses) {
        this.loadData = true
        this.getCourses()
      }
      this.showCreateEditCourseModal = false
    },
  },

  mounted() {
    this.getCourses()
  },
}
</script>
